import React, { useState } from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Testimonial from '../Testimonial';
import Div from '../Div';
import Spacing from '../Spacing';
const testimonialData = [
  {
    testimonialThumb: '/images/1.png',
    testimonialText:
      'Just Charge did an incredible job producing our podcast. Their expertise in storytelling, seamless execution, and attention to detail made the entire process smooth. The quality and creativity they brought to the table truly elevated our content. A fantastic team to work with!',
    avatarName: 'Dhimant Parekh ',
    avatarDesignation: 'Better India',
    ratings: '4',
  },

  {
    testimonialThumb: '/images/2.png',
    testimonialText:
      'Just Charge has been instrumental in transforming our digital presence. Their expertise in social media, SEO, and app development has helped Anodyne reach a wider audience and enhance patient engagement. Highly recommended!',
    avatarName: 'Hitesh Khurana',
    avatarDesignation: 'Anodyne',
    ratings: '4',
  },
  {
    testimonialThumb: '/images/3.png',
    testimonialText:
      'The team at Just Charge delivered a stunning website that perfectly represents GO Productions. Their attention to detail and seamless execution made the entire process effortless. Truly professional! ',
    avatarName: 'Dhananjay Singh',
    avatarDesignation: 'GO Productions',
    ratings: '5',
  },
  {
    testimonialThumb: '/images/4.png',
    testimonialText:
      'From strategy to execution, Just Charge has managed our 360° marketing with precision. Their innovative approach and dedication have significantly boosted our brand presence. A fantastic team to work with! ',
    avatarName: 'Shalineder Pratap Singh',
    avatarDesignation: 'Industrywala',
    ratings: '4.5',
  },
  {
    testimonialThumb: '/images/5.png',
    testimonialText:
      'Just Charge has elevated Pansh Jewels with its exceptional marketing strategies. Their creative approach, combined with data-driven insights, has been a game-changer for our brand. ',
    avatarName: 'Prince Goel',
    avatarDesignation: 'Panash Jewels',
    ratings: '3.5',
  },
  {
    testimonialThumb: "/images/6.png",
    testimonialText: "Our shoot with Just Charge was an absolute success! Their creative vision and execution brought our brand to life with stunning visuals. Couldn’t have asked for a better experience!",
    avatarName: "Nikhil Sharma",
    avatarDesignation: "Lacquer Embassy",
    ratings: "5"
  },
  {
    testimonialThumb: "/images/7.png",
    testimonialText: "The branding Just Charge created for me speaks volumes about their expertise. It’s professional, modern, and perfectly aligns with my vision. Highly recommend their services!",
    avatarName: "Dt. Sanjana",
    avatarDesignation: "Personal Branding",
    ratings: "4.5"
  },
  {
    testimonialThumb: "/images/8.png",
    testimonialText: "Just Charge crafted a strong brand identity for Kareer Coach. Their strategic approach and keen understanding of branding made a significant impact. A brilliant team to work with!",
    avatarName: "Tejeshwar Bakshi",
    avatarDesignation: "Kareer Coach",
    ratings: "4.5"
  },
  {
    testimonialThumb: "/images/9.png",
    testimonialText: "Branding is everything, and Just Charge nailed it for Samtonic! Their creative direction and detailed execution made our brand stand out in a competitive market.",
    avatarName: "Tushar Makhija",
    avatarDesignation: "Samtonic",
    ratings: "5"
  },
  {
    "testimonialThumb": "/images/10.png",
    "testimonialText": "The shoot with Just Charge was exceptional. Their team understood our vision and delivered stunning visuals that captured the essence of Colexion perfectly!",
    "avatarName": "Abhay Aggarwal",
    "avatarDesignation": "Colexion",
    "ratings": "5"
  },
  {
    "testimonialThumb": "/images/11.png",
    "testimonialText": "Just Charge delivered an outstanding shoot for Kikori. Their creativity and professionalism exceeded our expectations, and the results were phenomenal!",
    "avatarName": "Kendra Bostick",
    "avatarDesignation": "Kikori",
    "ratings": "4.5"
  },
  {
    "testimonialThumb": "/images/12.png",
    "testimonialText": "The Just Charge team brought Onsara’s brand aesthetics to life with their shoot. Their expertise in visuals and branding is truly commendable.",
    "avatarName": "Tanya",
    "avatarDesignation": "Onsara",
    "ratings": "4"
  },
  // {
  //   "testimonialThumb": "/images/testimonial_1.jpeg",
  //   "testimonialText": "The shoot Just Charge executed for Pranam was flawless. Their team is creative, professional, and dedicated to delivering high-quality visuals.",
  //   "avatarName": "Anjali Kalia",
  //   "avatarDesignation": "Pranam",
  //   "ratings": "4.5"
  // },
  {
    "testimonialThumb": "/images/22.png",
    "testimonialText": "Just Charge has handled our website and social media with absolute professionalism. Their strategic approach has given Carify a strong digital presence!",
    "avatarName": "Vinay",
    "avatarDesignation": "Carify",
    "ratings": "5"
  },
  {
    "testimonialThumb": "/images/16.png",
    "testimonialText": "Our new website, crafted by Just Charge, is sleek, modern, and user-friendly. They understood our brand and delivered beyond expectations!",
    "avatarName": "Akshat Gaba",
    "avatarDesignation": "Hanfei",
    "ratings": "4.5"
  },
  {
    "testimonialThumb": "/images/18.png",
    "testimonialText": "The shoot for Tog & Trim was seamless and well-executed. Just Charge captured the essence of our brand with stunning visuals!",
    "avatarName": "Sachi",
    "avatarDesignation": "Tog & Trim",
    "ratings": "4.5"
  },
  {
    "testimonialThumb": "/images/13.png",
    "testimonialText": "Just Charge's shoot for Jump USA was exceptional. Their attention to detail and creativity made all the difference in presenting our brand!",
    "avatarName": "Sristi",
    "avatarDesignation": "Jump USA",
    "ratings": "4.5"
  },
  // {
  //   "testimonialThumb": "/images/testimonial_1.jpeg",
  //   "testimonialText": "Just Charge streamlined our CRM system, making operations smoother and more efficient. Their technical expertise is unmatched!",
  //   "avatarName": "Gaurav",
  //   "avatarDesignation": "Autocredits",
  //   "ratings": "5"
  // },
  {
    "testimonialThumb": "/images/21.png",
    "testimonialText": "The branding Just Charge created for Cicada was spot-on. Their creative direction helped establish a strong identity for our brand!",
    "avatarName": "Srijit",
    "avatarDesignation": "Cicada",
    "ratings": "4.5"
  },
  {
    "testimonialThumb": "/images/17.png",
    "testimonialText": "Just Charge nailed the shoots for Mr. Button. Their ability to bring our designs to life with compelling visuals is truly impressive!",
    "avatarName": "Sandeep Jain",
    "avatarDesignation": "Mr. Button",
    "ratings": "5"
  },
  {
    "testimonialThumb": "/images/20.png",
    "testimonialText": "Our social media presence has grown significantly thanks to Just Charge. Their strategies and execution have been invaluable to Starwatt!",
    "avatarName": "Aishwarya",
    "avatarDesignation": "Starwatt",
    "ratings": "4.5"
  },
  {
    "testimonialThumb": "/images/15.png",
    "testimonialText": "The shoot for YAM India was handled with great creativity and professionalism. Just Charge knows how to capture the perfect shot!",
    "avatarName": "Priya",
    "avatarDesignation": "YAM India",
    "ratings": "4"
  },
  {
    "testimonialThumb": "/images/3.png",
    "testimonialText": "The Just Charge team delivered a brilliant shoot for Root Artist. Their ability to translate concepts into powerful visuals is remarkable!",
    "avatarName": "Ranvijay Paul",
    "avatarDesignation": "Root Artist",
    "ratings": "4.5"
  },
  // {
  //   "testimonialThumb": "/images/testimonial_1.jpeg",
  //   "testimonialText": "The website Just Charge developed for us is both functional and aesthetically pleasing. Their team ensured a smooth process from start to finish!",
  //   "avatarName": "Dr. Ashwin Fernandes",
  //   "avatarDesignation": "Pact Foundation",
  //   "ratings": "5"
  // },
  {
    "testimonialThumb": "/images/14.png",
    "testimonialText": "Just Charge executed an outstanding shoot for Oziss. Their creative direction and high-quality visuals made all the difference!",
    "avatarName": "Siddhant",
    "avatarDesignation": "Oziss",
    "ratings": "4.5"
  },
  {
    "testimonialThumb": "/images/19.png",
    "testimonialText": "Branding is at the heart of any successful business, and Just Charge delivered beyond expectations for Ghazi Kasheer. Their expertise is truly commendable!",
    "avatarName": "Gazi Rouhallah",
    "avatarDesignation": "Ghazi Kasheer",
    "ratings": "5"
  },
  // {
  //   "testimonialThumb": "/images/testimonial_1.jpeg",
  //   "testimonialText": "Just Charge has done an incredible job managing Eskyrise’s social media. Their strategies and execution have significantly enhanced our brand’s digital presence!",
  //   "avatarName": "Md. Saleem Saifi",
  //   "avatarDesignation": "Eskyrise",
  //   "ratings": "4.5"
  // }
];

export default function TestimonialSlider() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );

  return (
    <>
      <Div className="cs-gradient_bg_1 cs-shape_wrap_3 cs-parallax">
        <Spacing lg="130" md="80" />
        <Div className="cs-shape_3 cs-to_up">
          <img src="/images/shape_1.svg" alt="Shape" />
        </Div>
        <Div className="container">
          <Div className="cs-testimonial_slider">
            <Div className="cs-testimonial_slider_left">
              <Slider
                asNavFor={nav1}
                ref={slider2 => setNav2(slider2)}
                slidesToShow={3}
                swipeToSlide={true}
                focusOnSelect={true}
                centerMode={true}
                centerPadding="0px"
                arrows={false}
                // Added autoplay settings for the thumbnail slider
                autoplay={true}
                autoplaySpeed={4000}
                pauseOnHover={true}
              >
                {testimonialData.map((item, index) => (
                  <Div className="slider-nav_item" key={index}>
                    <Div className="cs-rotate_img">
                      <Div className="cs-rotate_img_in">
                        <img src={item.testimonialThumb} alt="Thumb" />
                      </Div>
                    </Div>
                  </Div>
                ))}
              </Slider>
            </Div>
            <Div className="cs-testimonial_slider_right">
              <Slider
                asNavFor={nav2}
                ref={slider1 => setNav1(slider1)}
                prevArrow={<SlickArrowLeft />}
                nextArrow={<SlickArrowRight />}
                className="cs-arrow_style1"
                // Added autoplay settings for the main testimonial slider
                autoplay={true}
                autoplaySpeed={4000}
                pauseOnHover={true}
              >
                {testimonialData.map((item, index) => (
                  <Div key={index}>
                    <Testimonial
                      testimonialText={item.testimonialText}
                      avatarName={item.avatarName}
                      avatarDesignation={item.avatarDesignation}
                      ratings={item.ratings}
                    />
                  </Div>
                ))}
              </Slider>
            </Div>
          </Div>
        </Div>
        <Spacing lg="130" md="80" />
      </Div>
    </>
  );
}